import { useEffect, useRef } from 'react';
import { AddSpacesInitialRecenterParams } from 'hooks/use-add-spaces-initial-recenter-params';
import { waitForElementSize } from 'utils/wait-for-element-size';

export function useAddSpacesInitialRecenter({
  isAddSpacesStep,
  show3DView,
  selectedLevelIndex,
  addSpacesIndex,
  structureUniqueId,
  structureGridRef,
  handleRecenterRef
}: AddSpacesInitialRecenterParams): void {
  const hasDoneAddSpacesRecenterRef = useRef(false);
  const addSpacesRecenterPendingRef = useRef(false);
  const prevAddSpacesStepRef = useRef(false);

  useEffect(() => {
    hasDoneAddSpacesRecenterRef.current = false;
    addSpacesRecenterPendingRef.current = false;
    prevAddSpacesStepRef.current = false;
  }, [structureUniqueId]);

  useEffect(() => {
    const justEnteredAddSpaces =
      !prevAddSpacesStepRef.current && isAddSpacesStep;
    prevAddSpacesStepRef.current = isAddSpacesStep;

    if (justEnteredAddSpaces && !hasDoneAddSpacesRecenterRef.current) {
      addSpacesRecenterPendingRef.current = true;
    }

    if (
      !isAddSpacesStep ||
      show3DView ||
      !addSpacesRecenterPendingRef.current ||
      hasDoneAddSpacesRecenterRef.current
    ) {
      return undefined;
    }

    let cancelled = false;
    const timeoutId = setTimeout(() => {
      waitForElementSize(
        () => structureGridRef.current,
        () => cancelled
      ).then((container) => {
        if (!container || cancelled || hasDoneAddSpacesRecenterRef.current) {
          return;
        }
        if (handleRecenterRef.current()) {
          hasDoneAddSpacesRecenterRef.current = true;
          addSpacesRecenterPendingRef.current = false;
        }
      });
    }, 0);

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [
    isAddSpacesStep,
    show3DView,
    selectedLevelIndex,
    addSpacesIndex,
    structureUniqueId,
    structureGridRef,
    handleRecenterRef
  ]);
}
